import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import InputConfig from '../../../../Components/InputConfig';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
//===============

const ThumbnailUrlConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Thumbnail Url"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Thumbnail Url']}
				description="Add/Remove Thumbnail Url for Framerate Player (Keep it empty for no thumbnail else put a valid thumbnail url)"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginTop: '4rem', marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={4}>
					<InputConfig
						label="Thumbnail Url"
						keyData={keyData}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default ThumbnailUrlConfig;
